// src/components/AnonymizationProfilesPage/ProfileBasicsSection.jsx
import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ProfileBasicsSection = ({ name, description, onNameChange, onDescriptionChange }) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                p: 3,
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider', // Semantic token, adapts to light/dark
                bgcolor: 'background.paper',
            }}
        >
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {t('anonymizationProfiles.basicsTitle', 'Základné informácie')}
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                    label={t('anonymizationProfiles.name', 'Názov profilu')}
                    value={name}
                    onChange={(e) => onNameChange(e.target.value)}
                    fullWidth
                    required
                    variant="outlined"
                    InputProps={{ sx: { borderRadius: 2 } }}
                />

                <TextField
                    label={t(
                        'anonymizationProfiles.description',
                        'Popis (voliteľné)'
                    )}
                    value={description}
                    onChange={(e) => onDescriptionChange(e.target.value)}
                    fullWidth
                    multiline
                    minRows={3}
                    variant="outlined"
                    InputProps={{ sx: { borderRadius: 2 } }}
                />
            </Box>
        </Box>
    );
};

export default ProfileBasicsSection;